import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { Suspense } from "react";

import ReactDOM from "react-dom/client";
import App from "./App";
import { CLIENT_ID } from "./utils/env";
import { ModalPortal } from "./portal";
import { WeeklyRewardsPreview } from "./dev/WeeklyRewardsPreview";

const isMakerMonitoringPreview = () =>
  process.env.NODE_ENV === "development" &&
  window.location.hostname === "localhost" &&
  window.location.port === "3000" &&
  window.location.pathname === "/makers" &&
  new URLSearchParams(window.location.search).get("makerMonitorFixture") ===
    "1";
const MakerMonitoringPreview =
  process.env.NODE_ENV === "development"
    ? React.lazy(() =>
        import("./dev/MakerMonitoringPreview").then((m) => ({
          default: m.MakerMonitoringPreview,
        }))
      )
    : () => null;

const AffiliateDashboardPreview =
  process.env.NODE_ENV === "development"
    ? React.lazy(() => import("./dev/AffiliateDashboardPreview"))
    : () => null;

const isAffiliatePreview = () =>
  process.env.NODE_ENV === "development" &&
  window.location.hostname === "localhost" &&
  window.location.port === "3000" &&
  window.location.pathname === "/affiliates" &&
  new URLSearchParams(window.location.search).get("affiliatePreview") === "1";

const isKillSwitchPreview = () =>
  process.env.NODE_ENV === "development" &&
  window.location.hostname === "localhost" &&
  window.location.port === "3000" &&
  window.location.pathname === "/__preview/kill-switch-approvals";
const KillSwitchApprovalPreview =
  process.env.NODE_ENV === "development"
    ? React.lazy(() => import("./dev/KillSwitchApprovalPreview"))
    : () => null;

function renderApplication() {
  if (isKillSwitchPreview())
    return (
      <Suspense fallback={<p>Loading local preview…</p>}>
        <KillSwitchApprovalPreview />
      </Suspense>
    );
  if (isAffiliatePreview())
    return (
      <Suspense fallback={<p>Loading local preview…</p>}>
        <AffiliateDashboardPreview />
      </Suspense>
    );
  if (isMakerMonitoringPreview())
    return (
      <Suspense fallback={<p>Loading local preview…</p>}>
        <MakerMonitoringPreview />
      </Suspense>
    );
  if (
    process.env.NODE_ENV === "development" &&
    window.location.pathname === "/__preview/weekly-rewards"
  )
    return <WeeklyRewardsPreview />;
  return (
    <>
      <App />
      <ModalPortal />
    </>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  isAffiliatePreview() ||
    isMakerMonitoringPreview() ||
    isKillSwitchPreview() ? (
      <React.StrictMode>{renderApplication()}</React.StrictMode>
  ) : (
    <GoogleOAuthProvider clientId={CLIENT_ID()}>
      <React.StrictMode>{renderApplication()}</React.StrictMode>
    </GoogleOAuthProvider>
  )
);
